/**
 * Canonical receipt photo slots. These names are stored as the photo caption
 * and match the Dispatch app, so the PDF and gallery order by them.
 * Keep in sync with server/src/modules/collections/receipts/photoSlots.ts.
 */
export const RECEIPT_PHOTO_SLOTS = [
  'customer_id',
  'customer_address_proof',
  'car_front',
  'car_rear',
  'car_reg',
  'chassis_photo',
  'logbook_photo',
] as const;

export type ReceiptPhotoSlot = (typeof RECEIPT_PHOTO_SLOTS)[number];

export const PHOTO_SLOT_LABELS: Record<string, string> = {
  customer_id: 'Customer ID',
  customer_address_proof: 'Address Proof',
  car_front: 'Vehicle Front',
  car_rear: 'Vehicle Rear',
  car_reg: 'Registration Plate',
  chassis_photo: 'Chassis',
  logbook_photo: 'Logbook',
};

export type SlotFiles = Partial<Record<ReceiptPhotoSlot, File>>;

/** Files in canonical slot order with their parallel captions, ready to upload. */
export function slotFilesToUpload(slots: SlotFiles): { files: File[]; captions: ReceiptPhotoSlot[] } {
  const files: File[] = [];
  const captions: ReceiptPhotoSlot[] = [];
  for (const slot of RECEIPT_PHOTO_SLOTS) {
    const f = slots[slot];
    if (f !== undefined) {
      files.push(f);
      captions.push(slot);
    }
  }
  return { files, captions };
}
